

























import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class ModalContainer extends Vue {
  @Prop() public title?: string
  @Prop() public component?: () => Vue
  @Prop() public componentArgs!: any
  @Prop({default: ''}) public width?: string
  private display: string = 'none'

private mounted() {
    this.show()
  }

  private show() {
    this.display = 'block'
  }

  private close() {
    this.$emit('close')
  }
}
